import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-02ae42f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "item-expansion"
}
const _hoisted_2 = {
  key: 1,
  class: "item-expansion"
}
const _hoisted_3 = { class: "item-floc" }
const _hoisted_4 = { class: "item-floc-desc" }
const _hoisted_5 = { class: "item-is-asset" }
const _hoisted_6 = { class: "item-asset-class" }
const _hoisted_7 = { class: "item-actions" }

import { FunctionalLocation } from "@/classes";
import { TreeItem, depthSequence } from "./tree";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionalLocationRow',
  props: {
    treeItem: {},
    depth: {}
  },
  emits: ["expand", "collapse", "view"],
  setup(__props: any) {

const props = __props;


const children = computed(() => {
  if (props.treeItem.expanded && Array.isArray(props.treeItem.children)) {
    return props.treeItem.children;
  } else {
    return [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_FunctionalLocationRow = _resolveComponent("FunctionalLocationRow", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass({
      [_unref(depthSequence)[_ctx.depth % _unref(depthSequence).length].row]: true,
    })
    }, [
      (_ctx.treeItem.item.metrics.children_count > 0)
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            _createElementVNode("div", {
              style: _normalizeStyle({ 'padding-left': Math.min(_ctx.depth, 12) * 12 + 'px' })
            }, [
              (!_ctx.treeItem.expanded)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    icon: "mdi-chevron-right",
                    variant: "plain",
                    density: "compact",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('expand', _ctx.treeItem)))
                  }))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    icon: "mdi-chevron-down",
                    variant: "plain",
                    density: "compact",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('collapse', _ctx.treeItem)))
                  }))
            ], 4)
          ]))
        : (_openBlock(), _createElementBlock("td", _hoisted_2)),
      _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.treeItem.item.functional_location), 1),
      _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.treeItem.item.functional_location_description), 1),
      _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.treeItem.item.is_asset_text), 1),
      _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.treeItem.item.asset_class_name), 1),
      _createElementVNode("td", _hoisted_7, [
        _createVNode(_component_v_btn, {
          icon: "mdi-eye",
          variant: "plain",
          density: "compact",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('view', _ctx.treeItem)))
        })
      ])
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children.value, (child) => {
      return (_openBlock(), _createBlock(_component_FunctionalLocationRow, {
        key: child.item.id,
        "tree-item": child,
        depth: _ctx.depth + 1,
        onExpand: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('expand', $event))),
        onCollapse: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('collapse', $event))),
        onView: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('view', $event)))
      }, null, 8, ["tree-item", "depth"]))
    }), 128))
  ], 64))
}
}

})